import { AnimationTriggerMetadata, trigger, state, transition, style, animate } from '@angular/animations';

export const toastAnimations: {
	readonly fadeToast: AnimationTriggerMetadata;
} = {
	fadeToast: trigger('fadeInOutAnimation', [
		transition(':enter', [
			style({ transform: 'scale(0.8)', opacity: 0 }),
			animate('75ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 1 })),
		]),
		transition(':leave', [
			animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)', opacity: 0 })),
		]),
	]),
};
